import { Link } from 'react-router-dom';
import { categories } from '@/mocks/data';

export default function Footer() {
  return (
    <footer className="bg-foreground-950 text-foreground-300">
      <div className="w-full px-4 md:px-6 py-14">
        <div className="max-w-7xl mx-auto">
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-10">
            <div>
              <Link to="/" className="flex items-center gap-2 mb-4 cursor-pointer">
                <div className="w-9 h-9 rounded-lg bg-primary-500 flex items-center justify-center">
                  <i className="ri-play-fill text-background-50 text-lg"></i>
                </div>
                <span className="text-xl font-heading font-bold text-background-50">小蓝视频</span>
              </Link>
              <p className="text-sm leading-relaxed text-foreground-400">
                小蓝视频——高清不缓冲在线观看平台。聚合91视频、芒果视频、91在线视频、菠萝视频、51视频等优质资源，最新电影电视剧随心看。
              </p>
            </div>

            <div>
              <h4 className="text-sm font-semibold text-background-50 mb-4">视频分类</h4>
              <ul className="space-y-2.5">
                {categories.map((cat) => (
                  <li key={cat.id}>
                    <Link
                      to={`/category/${cat.slug}`}
                      className="text-sm text-foreground-400 hover:text-background-50 transition-colors cursor-pointer"
                    >
                      {cat.name}
                    </Link>
                  </li>
                ))}
              </ul>
            </div>

            <div>
              <h4 className="text-sm font-semibold text-background-50 mb-4">快捷链接</h4>
              <ul className="space-y-2.5">
                <li>
                  <Link to="/" className="text-sm text-foreground-400 hover:text-background-50 transition-colors cursor-pointer">
                    首页
                  </Link>
                </li>
                <li>
                  <Link to="/about" className="text-sm text-foreground-400 hover:text-background-50 transition-colors cursor-pointer">
                    关于我们
                  </Link>
                </li>
                <li>
                  <a href="/category/dianying" className="text-sm text-foreground-400 hover:text-background-50 transition-colors cursor-pointer">
                    热门电影
                  </a>
                </li>
                <li>
                  <a href="/category/dianshiju" className="text-sm text-foreground-400 hover:text-background-50 transition-colors cursor-pointer">
                    热门电视剧
                  </a>
                </li>
              </ul>
            </div>

            <div>
              <h4 className="text-sm font-semibold text-background-50 mb-4">联系我们</h4>
              <ul className="space-y-2.5">
                <li className="flex items-center gap-2 text-sm text-foreground-400">
                  <i className="ri-mail-line"></i>
                  <span>contact@xiaolanvideo.com</span>
                </li>
                <li className="flex items-center gap-2 text-sm text-foreground-400">
                  <i className="ri-phone-line"></i>
                  <span>400-888-0000</span>
                </li>
                <li className="flex items-center gap-2 text-sm text-foreground-400">
                  <i className="ri-map-pin-line"></i>
                  <span>北京市朝阳区建国路88号</span>
                </li>
              </ul>
            </div>
          </div>

          <div className="mt-12 pt-8 border-t border-foreground-800 flex flex-col sm:flex-row items-center justify-between gap-4">
            <p className="text-xs text-foreground-500">
              &copy; {new Date().getFullYear()} 小蓝视频 XiaolanVideo.com 版权所有
            </p>
            <div className="flex items-center gap-4">
              <a href="#" className="text-xs text-foreground-500 hover:text-background-50 transition-colors cursor-pointer">隐私政策</a>
              <a href="#" className="text-xs text-foreground-500 hover:text-background-50 transition-colors cursor-pointer">服务条款</a>
              <a href="#" className="text-xs text-foreground-500 hover:text-background-50 transition-colors cursor-pointer">免责声明</a>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
}